/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Generic_Auth_NoteInputs */



/**
* | output |
* | --- |
* | "Use Bearer token authentication with the token provided above." |
*
* @param {Scim_Setup_Generic_Auth_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_generic_auth_note = /** @type {((inputs?: Scim_Setup_Generic_Auth_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Generic_Auth_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie Bearer-Token-Authentifizierung mit dem oben angegebenen Token.")
	return /** @type {LocalizedString} */ ("Use Bearer token authentication with the token provided above.")
});